module.exports = "<div class=\"row\" [ngStyle]=\"{'background-color': background, 'justify-content': align, 'align-items': alignItems, 'padding': padding, 'height': height, 'width': width, 'flex-wrap': wrap}\">\r\n  <ng-content></ng-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/row/row.component.html
// module id = ./src/app/components/row/row.component.html
// module chunks = main